import React, { useState, useEffect } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import {
  Container, Typography, Select, MenuItem, TextField, Button, Box, Grid, Paper, Switch, FormControlLabel, Chip,
  Alert
} from "@mui/material";
import OpenTransactionStatus from "./components/CashRegisterDemo/OpenTransactionStatus";

import de from 'javascript-time-ago/locale/de'
import TimeAgo from 'javascript-time-ago';
import ReactTimeAgo from 'react-time-ago';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip
} from "@mui/material";
import VoidText from "./components/CashRegisterDemo/VoidText";
TimeAgo.addDefaultLocale(de);

const VALID_CLIENTS = ["34828a3d-7cc6-42dd-9174-09ed7837998e"];
const PRODUCTS = [
  { name: "Paket S", price: 3.4, sku: "mps1" },
  { name: "Paket L", price: 7.8, sku: "mps2" },
  { name: "Paket XL", price: 24.5, sku: "mps3" }
];

const KASSE_ENDPOINT = 'https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod';
const AUTH_SECRET = 'supersecret';

const authHeaders = {
  headers: {
    Authorization: `Bearer ${AUTH_SECRET} y 1 z`,
  },
};

export default function CashRegisterDemo({cashier_name, store_number}) {
  const [clientId, setClientId] = useState(VALID_CLIENTS[0]);
  const [transactionId, setTransactionId] = useState(null);
  const [cart, setCart] = useState([]);
  const [amountGiven, setAmountGiven] = useState(0);
  const [receipt, setReceipt] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [stornoMode, setStornoMode] = useState(false);
  const [trainingMode, setTrainingMode] = useState(false);
  const [reversalBase, setReversalBase] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [cancelledQuantities, setCancelledQuantities] = useState({});

  const [revision, setRevision] = useState(1);

  const [paymentMethod, setPaymentMethod] = useState("CASH"); // "CASH" or "CARD"
const [cardType, setCardType] = useState("VISA");
const [cardStatus, setCardStatus] = useState("succeeded"); // succeeded | declined | failed


  const getTotal = (items) => items.reduce((sum, p) => sum + p.qty * (p.storno ? -p.price : p.price), 0).toFixed(2);

  const buildSchema = (items) => {
    const total = getTotal(items);
    return {
      standard_v1: {
        receipt: {
          receipt_type: trainingMode ? "TRAINING" : "RECEIPT",
          amounts_per_vat_rate: [{ vat_rate: "19", amount: total }],
          amounts_per_payment_type: [{ payment_type: paymentMethod === "CARD" ? "CARD" : "CASH", amount: total, currency_code: "EUR" }],
          items: items.map((p, index) => {
            const itemTotal = (p.qty * p.price) * (p.storno ? -1 : 1);
            return {
              lineitem_export_id: `${index + 1}`,
              business_case: {
                type: "Umsatz",
                name: p.name,
                amounts_per_vat_id: [{ vat_rate: "19", amount: itemTotal.toFixed(2) }]
              },
              in_house: false,
              storno: p.storno || false,
              text: p.name,
              item: {
                number: p.sku,
                quantity: p.qty,
                quantity_factor: 1,
                quantity_measure: "STK",
                group_id: "default",
                group_name: "Allgemein",
                price_per_unit: p.price
              }
            };
          })
        }
      }
    };
  };

  const mockTransactionDetails = (cardType, cardStatus) => {
  const now = Math.floor(Date.now() / 1000);
  const id = uuidv4();

  const networkMap = {
    VISA: "VISA",
    Mastercard: "MASTERCARD",
    TWINT: "OTHER",
    EC: "MAESTRO"
  };

  return {
    AID: "A0000000031010",
    ARN: `ARN-${Math.floor(Math.random() * 1e8)}`,
    acquirer_id: "ACQ1234567",
    authorization_code: (cardStatus === "succeeded" ? "AUTHOK" : "DECLINED").substring(0, 6),
    cryptogram: "AB12CD34EF56",
    id,
    local_date_time: now,
    payment_network: networkMap[cardType] || "OTHER",
    payment_type: "DEBIT",
    response: {
      succeeded: "ACCEPTED",
      declined: "DECLINED",
      failed: "CANCELLED"
    }[cardStatus] || "CANCELLED",
    sequence_number: String(Math.floor(Math.random() * 1000)),
    technology: "EMV",
    terminal_id: "TERM001",
    type: "POS"
  };
};


  const addProduct = (product) => {
    if (!transactionId) return;
  
    const sku = product.sku;
  
    // Offene Transaktion, Storno aktiv, kein reversalBase
    if (stornoMode && !reversalBase) {
      const alreadyAddedQty = cart
        .filter(p => p.sku === sku && !p.storno)
        .reduce((sum, p) => sum + p.qty, 0);
  
      const alreadyStornoQty = cart
        .filter(p => p.sku === sku && p.storno)
        .reduce((sum, p) => sum + p.qty, 0);
  
      const stillAllowed = alreadyAddedQty - alreadyStornoQty;
      if (stillAllowed <= 0) {
        alert("Nur bereits erfasste Produkte können storniert werden.");
        return;
      }
    }
  
    // Storno einer abgeschlossenen Transaktion
    if (stornoMode && reversalBase) {
      const originalItem = selectedItems.find(i => i.item.number === sku);
      const maxQty = originalItem?.item?.quantity || 0;
      const alreadyCancelled = cancelledQuantities[sku] || 0;
      const stillAllowed = maxQty - alreadyCancelled;
      if (stillAllowed <= 0) return;
    }
  
    // Neuer Eintrag (nicht ersetzen!)
    const newEntry = {
      ...product,
      qty: 1,
      storno: stornoMode
    };
    const updatedCart = [...cart, newEntry];
    setCart(updatedCart);
    updateTransaction(updatedCart);
  
    if (stornoMode && reversalBase) {
      const newQty = (cancelledQuantities[sku] || 0) + 1;
      setCancelledQuantities(prev => ({ ...prev, [sku]: newQty }));
    }
  };
  
  

  const startTransaction = async () => {
    const txId = uuidv4();
    setRevision(1);
    setTransactionId(txId);
    setReceipt(null);
    setCart([]);
    setReversalBase(null);
    setSelectedItems([]);
    setCancelledQuantities({});
    await axios.post(KASSE_ENDPOINT + "/transactions", {
      action: "start",
      client_id: clientId,
      transaction_id: txId,
      tss_id: clientId,
      revision
    }, authHeaders);
    setRevision(revision + 1);
  };

  const cancelTransaction = async () => {
    await axios.post(KASSE_ENDPOINT + "/transactions", {
      action: "cancel",
      client_id: clientId,
      transaction_id: transactionId,
      tss_id: clientId,
      revision
    }, authHeaders);
    setRevision(revision + 1);
    setTransactionId(null);
    setCart([]);
    setReversalBase(null);
    setSelectedItems([]);
    setCancelledQuantities({});
    setStornoMode(false); // ← ADD THIS
  };

  const updateTransaction = async (customCart = cart) => {
    if (!transactionId) return;
    const schema = buildSchema(customCart);
    try {
      await axios.post(KASSE_ENDPOINT + "/transactions", {
        action: "update",
        client_id: clientId,
        transaction_id: transactionId,
        tss_id: clientId,
        revision,
        schema
      }, authHeaders);
      setRevision(revision + 1);
    } catch (err) {
      console.error("Update failed:", err.response?.data || err);
    }
  };

  const finishTransaction = async () => {
    if (!transactionId) return;
    const schema = buildSchema(cart);
    const total = parseFloat(getTotal(cart));
    if (amountGiven < total) {
      alert("Gegebener Betrag ist kleiner als der Gesamtbetrag.");
      return;
    }
    const change = amountGiven - total;

    const payment = paymentMethod === "CASH"
  ? { method: "CASH", given: amountGiven, change }
  : {
      method: "CARD",
      type: cardType,
      status: cardStatus,
      amount: total
    };


    const transaction_details = paymentMethod === "CARD"
  ? mockTransactionDetails(cardType, cardStatus)
  : undefined;

  
    const result = await axios.post(KASSE_ENDPOINT + "/transactions", {
      action: "finish",
      client_id: clientId,
      transaction_id: transactionId,
      payment,
      tss_id: clientId,
      schema,
      training_mode: trainingMode,
      ...(transaction_details ? { transaction_details } : {}),
      ...(reversalBase ? { reversal_of: reversalBase } : {}),
      revision
    }, authHeaders);
    setRevision(revision + 1);
    setReceipt(result.data);
    setTransactionId(null);
    setCart([]);
    setReversalBase(null);
    setSelectedItems([]);
    setCancelledQuantities({});
    loadTransactions();
    setStornoMode(false);

  };

  const loadTransactions = async () => {
    const { data } = await axios.get(KASSE_ENDPOINT + `/transactions?client_id=${clientId}`, authHeaders);
    setTransactions(data.items);
  };

  const prepareReversal = (tx) => {
    const originalItems = tx.Items || [];
    const cancelled = tx.CancelledItems || {};
  
    // Gruppiere nach SKU mit Summierung, getrennt nach storno und nicht storno
    const aggregated = {};
  
    for (const item of originalItems) {
      const sku = item?.item?.number;
      const qty = parseFloat(item?.item?.quantity || 0);
      const isStorno = item?.storno === true;
  
      if (!sku || isNaN(qty)) continue;
  
      if (!aggregated[sku]) {
        aggregated[sku] = {
          ...item,
          item: { ...item.item, quantity: 0 },
          storno: false
        };
      }
  
      // Addiere bzw. subtrahiere je nach Storno-Flag
      aggregated[sku].item.quantity += isStorno ? -qty : qty;
    }
  
    // Erstelle finale Liste mit nur positiven verbleibenden Mengen
    const adjustedItems = Object.values(aggregated)
      .map((entry) => {
        const sku = entry.item.number;
        const cancelledQty = cancelled[sku] || 0;
        const remainingQty = entry.item.quantity - cancelledQty;
        return {
          ...entry,
          item: {
            ...entry.item,
            quantity: remainingQty > 0 ? remainingQty : 0
          }
        };
      })
      .filter(item => item.item.quantity > 0); // nur noch stornierbare Einträge
  
    setReversalBase(tx.TransactionId);
    setCart([]);
    setTransactionId(uuidv4());
    setReceipt(null);
    setStornoMode(true);
    setTrainingMode(tx.TrainingMode === true);
    setSelectedItems(adjustedItems);
    setCancelledQuantities({});
  };

  useEffect(() => {
    loadTransactions();
  }, [clientId]);

  const loadOpenTransaction = async (tx) => {
    try {
      const { data } = await axios.get(`${KASSE_ENDPOINT}/transactions/${tx.TransactionId}`, authHeaders);

      if (data.State !== "ACTIVE") {
        alert("Diese Transaktion wurde bereits abgeschlossen und kann nicht mehr geladen werden.");
        return;
      }

      setTransactionId(data.TransactionId);
      setCart((data.Items || []).map(item => ({
        name: item.text,
        price: item.item.price_per_unit,
        sku: item.item.number,
        qty: item.item.quantity,
        storno: item.storno || false // <- FIX: preserve the storno state
      })));
      setRevision(data.Revision + 1)
      setReceipt(null);
      setStornoMode(false);
      setTrainingMode(data.TrainingMode === true);
      setReversalBase(null);
      setSelectedItems([]);
      setCancelledQuantities({});
    } catch (err) {
      console.error("Fehler beim Laden der Transaktion:", err);
      alert("Fehler beim Laden der Transaktion.");
    }
  };


  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <VoidText text={trainingMode && "TRAINING MODE"}>

        <OpenTransactionStatus onLoad={loadOpenTransaction} />

        <Typography variant="h4" gutterBottom>Kasse</Typography>



        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
          <Select value={clientId} onChange={e => setClientId(e.target.value)}>
            {VALID_CLIENTS.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </Select>
          <FormControlLabel
            control={<Switch checked={trainingMode} onChange={() => setTrainingMode(!trainingMode)} disabled={!!transactionId} />}
            label="Trainingsmodus"
          />
          {trainingMode && <Chip label="TRAINING MODUS AKTIVIERT" color="warning" />}
          {stornoMode && <Chip label="STORNO" color="error" />}
        </Box>

        {!transactionId ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
            <Button variant="contained" size="large" onClick={startTransaction}>
              Vorgang starten
            </Button>
          </Box>
        ) : (
          <>
            {/* Produktbuttons */}
            <Grid container spacing={2} mb={2}>
              {PRODUCTS.map(p => (
                <Grid item xs={4} key={p.name}>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => addProduct(p)}
                    color={stornoMode ? "error" : "primary"}
                  >
                    {p.name} – {stornoMode ? `–${p.price.toFixed(2)} €` : `${p.price.toFixed(2)} €`}
                  </Button>
                </Grid>
              ))}
            </Grid>

            {/* Warenkorb */}
            <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
              <Typography variant="h6">Warenkorb</Typography>
              {cart.map(p => (
                <Typography
                  key={p.name + (p.storno ? "-storno" : "")}
                  sx={{ color: p.storno ? 'error.main' : 'text.primary' }}
                >
                  {p.qty} × {p.name} – {p.storno ? "-" : ""}{(p.qty * p.price).toFixed(2)} €
                </Typography>

              ))}

              {reversalBase && selectedItems.length > 0 && (
                <Box sx={{ mb: 2 }}>
                  <Paper variant="outlined" sx={{ p: 2, backgroundColor: "#fff3e0" }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Stornierbare Positionen:</Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {selectedItems.map((item) => {
                        const max = item.item.quantity;
                        const current = cancelledQuantities[item.item.number] || 0;
                        const remaining = max - current;
                        return (
                          <Chip
                            key={item.item.number}
                            label={`${item.text}: ${remaining} von ${max}`}
                            color={remaining > 0 ? "warning" : "default"}
                          />
                        );
                      })}
                    </Box>
                  </Paper>
                </Box>
              )}

              <Typography sx={{ mt: 1 }}>Gesamt: {getTotal(cart)} €</Typography>
            </Paper>

            {/* Bezahlbereich */}
            {/* Bezahlbereich */}
<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
  <Box sx={{ display: 'flex', gap: 2 }}>
    <Select value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)}>
      <MenuItem value="CASH">Barzahlung</MenuItem>
      <MenuItem value="CARD">Kartenzahlung</MenuItem>
    </Select>

    {paymentMethod === "CARD" && (
      <>
        <Select value={cardType} onChange={e => setCardType(e.target.value)}>
          <MenuItem value="VISA">VISA</MenuItem>
          <MenuItem value="Mastercard">Mastercard</MenuItem>
          <MenuItem value="TWINT">TWINT</MenuItem>
          <MenuItem value="EC">EC</MenuItem>
        </Select>
        <Select value={cardStatus} onChange={e => setCardStatus(e.target.value)}>
          <MenuItem value="succeeded">Erfolgreich</MenuItem>
        </Select>
      </>
    )}
  </Box>

  <Box sx={{ display: 'flex', gap: 2 }}>
    <TextField
      label="Bar erhalten"
      type="number"
      value={amountGiven}
      onChange={e => setAmountGiven(parseFloat(e.target.value))}
      disabled={paymentMethod !== "CASH"}
    />
    <Button variant="contained" color="success" onClick={finishTransaction} disabled={!transactionId}>
      Bezahlen
    </Button>
  </Box>
</Box>

            {/* Vorgangsaktionen */}
            <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
              <Button variant="outlined" color="warning" onClick={() => updateTransaction()}>Aktualisieren</Button>
              <Button variant="outlined" color="error" onClick={cancelTransaction}>Abbrechen</Button>
              {!reversalBase && (
                <Button
                  variant={stornoMode ? "contained" : "outlined"}
                  color="error"
                  onClick={() => setStornoMode(prev => !prev)}
                >
                  {stornoMode ? "Storno-Modus aktiv" : "Storno aktivieren"}
                </Button>
              )}

              {reversalBase && (
                <Chip label="Storno-Vorgang läuft (Artikel hinzufügen nur im Minus erlaubt)" color="error" />
              )}
            </Box>
          </>
        )}

        {/* Bonanzeige */}
        {receipt?.ereceipt?.public_link?.href && (
          <Box mb={2}>
            <Button variant="outlined" color="primary" href={receipt.ereceipt.public_link.href} target="_blank">
              Bon anzeigen
            </Button>
          </Box>
        )}

        {trainingMode && <Alert severity="error">ACHTUNG Trainings-Modus aktiviert! Es werden keine Buchungen vorgenommen!</Alert>}

        {receipt?.remaining_reversal_amount && (
          <Typography color="warning.main" sx={{ mb: 2 }}>
            Verbleibender Storno-Betrag: {receipt.remaining_reversal_amount} €
          </Typography>
        )}
      </VoidText>

<CashpointClosingButton clientId={clientId}>XXX</CashpointClosingButton>


      {/* Vergangene Transaktionen */}
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>Letzte Transaktionen</Typography>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Betrag</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Zuletzt</TableCell>
                <TableCell align="right">Aktion</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.map((tx) => {
                const isFullyRefunded = tx.CancellationStatus === "full";
                const isPartiallyRefunded = tx.CancellationStatus === "partial";
                const isRefund = !!tx.ReversalOf;
                const original = transactions.find(t => t.TransactionId === tx.ReversalOf);
                const amount = (tx.Items || []).reduce((sum, p) => sum + p.item.quantity * p.item.price_per_unit * (p.storno ? -1 : 1), 0).toFixed(2);
                const isTrainingTx = tx.TrainingMode === true;



                return (
                  <TableRow key={tx.TransactionId}>
                    <TableCell sx={{ fontSize: '0.75rem' }}>
                      <Tooltip title={tx.TransactionId}>
                        <span>{tx.TransactionId.slice(0, 8)}…</span>
                        {isTrainingTx && (
                          <Chip size="small" label="🎓 Training" />
                        )}
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      {isRefund ? `- ${amount} €` : `${amount} €`}
                    </TableCell>
                    <TableCell>
                      {isRefund ? (
                        <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>↩️ Storno</span>
                      ) : isFullyRefunded ? (
                        <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>❌ Vollständig storniert</span>
                      ) : isPartiallyRefunded ? (
                        <span style={{ color: '#ed6c02', fontWeight: 'bold' }}>⚠️ Teilweise storniert</span>
                      ) : (
                        <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>✅ Abgeschlossen</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <Tooltip title={new Date((tx.UpdatedAt || 0) * 1000).toLocaleString("de-DE", { timeZone: "Europe/Berlin" })}>
                        <span>
                          <ReactTimeAgo date={(tx.UpdatedAt || 0) * 1000} locale="de" />
                        </span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="right">
                      {!isRefund && !isFullyRefunded && (
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => prepareReversal(tx)}
                        >
                          Storno / Refund
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

    </Container>
  );
}


function CashpointClosingButton({ clientId }) {
  const handleClosing = async () => {
    try {
      const res = await axios.post(
        KASSE_ENDPOINT + "/cash_point_closing",
        { client_id: clientId },
        {
          headers: {
            Authorization: "Bearer supersecret y 1 z",
            "Content-Type": "application/json"
          }
        }
      );
      alert("Z-Bericht erfolgreich erstellt: " + res.data.closing_id);
    } catch (err) {
      console.error(err);
      alert("Fehler beim Erstellen des Z-Berichts");
    }
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleClosing}
    >
      Z-Bericht / Tagesabschluss
    </Button>
  );
}